





















































import Vue from 'vue';
import { mapDataSource } from '../utils/mapDataSource';
import { mapState, mapMutations } from 'vuex';
export default Vue.extend({
    data() {
        return {
            pointTypeOptions: [{
                value: 'leijiliang',
                label: '累积量'
            }, {
                value: 'zifuchuanliang',
                label: '字符串量'
            }],

            deviceTypeOptions: [{
                value: 'kongtiao',
                label: '空调'
            }, {
                value: 'wangguan',
                label: '网关'
            }],

            deviceOptions: [{
                value: 'leijiliang',
                label: '设备1'
            }, {
                value: 'zifuchuanliang',
                label: '设备2'
            }],
        }
    },
    computed: {
        ...mapState({
            partSelection: (state: any) => state.screen.editor.partSelection
        }),
        ...mapDataSource({
            pointType: {
                // 需要从哪个对象上获取自身的属性
                carrier: 'pointData',
                // 设置自身属性的简单适配器
                getOption: (newValue: any) => {
                    return {
                        pointType: newValue,
                        mode: 'pointData',
                    }
                },
            },
            pointDeviceType: {
                carrier: 'pointData',
                getOption: (newValue) => {
                    return {
                        pointDeviceType: newValue,
                        mode: 'pointData',
                    }
                },
            },
            pointDevice: {
                carrier: 'pointData',
                getOption: (newValue) => {
                    return {
                        pointDevice: newValue,
                        mode: 'pointData',
                    }
                },
            },
            pointName: {
                carrier: 'pointData',
                getOption: (newValue) => {
                    return {
                        pointName: newValue,
                        mode: 'pointData',
                    }
                },
            },
        }),
        /**
         * 被选中的part数组
         */
        selectGroup(): Model.Part[] {
            return this.partSelection.selectGroup
        },
        /**
         * 当前选中的part
         * 目前只处理单个part
         */
        curSelectPart(): Model.Part {
            const { length } = this.selectGroup
            return length === 1 && this.isReleasePart ? this.selectGroup[0] : {}
        },
        /**
         * 优化选中part的性能
         * 修改为释放part，才更新配置项 -- 样式 or 数据
         */
        isReleasePart(): boolean {
            return this.partSelection.releasePart;
        },
        partData(): any {
            const partData = this.curSelectPart.partData;
            return partData;
        },
        pointData(): any {
            const pointData =  (this.partData && this.partData.pointData) || {};
            return pointData;
        },
    },
    methods: {
        ...mapMutations([
            'set_partData',
        ]),
    }
})
